




























































































import { Component, Vue, Prop } from "vue-property-decorator";
import ApolloClient, { serverBase } from "../apollo";
import gql from "graphql-tag";
import IMovie from "../types/movie";
import { copy } from "../util/object";
import moment from "moment";
import { ensureDarkColor } from "../util/color";
import Color from "color";

@Component
export default class MovieCard extends Vue {
  @Prop(Object) value!: IMovie;
  @Prop({ default: 0.71 }) ratio!: number;
  @Prop({ default: true }) showActors!: boolean;
  @Prop({ default: true }) showLabels!: boolean;
  @Prop({ default: true }) showBody!: boolean;
  @Prop({ default: true }) showRating!: boolean;
  @Prop({ default: true }) showSceneCount!: boolean;

  get complementary() {
    if (this.cardColor) return Color(this.cardColor).negate().hex() + " !important";
    return undefined;
  }

  get cardColor() {
    if (this.value.frontCover && this.value.frontCover.color)
      return ensureDarkColor(this.value.frontCover.color);
    return null;
  }

  get movieDuration() {
    if (this.value && this.value.duration)
      return moment()
        .startOf("day")
        .seconds(this.value.duration)
        .format(this.value.duration < 3600 ? "mm:ss" : "H:mm:ss");
    return "";
  }

  favorite() {
    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: MovieUpdateOpts!) {
          updateMovies(ids: $ids, opts: $opts) {
            favorite
          }
        }
      `,
      variables: {
        ids: [this.value._id],
        opts: {
          favorite: !this.value.favorite,
        },
      },
    }).then((res) => {
      const movie = copy(this.value);
      movie.favorite = res.data.updateMovies[0].favorite;
      this.$emit("input", movie);
    });
  }

  bookmark() {
    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: MovieUpdateOpts!) {
          updateMovies(ids: $ids, opts: $opts) {
            bookmark
          }
        }
      `,
      variables: {
        ids: [this.value._id],
        opts: {
          bookmark: this.value.bookmark ? null : Date.now(),
        },
      },
    }).then((res) => {
      const movie = copy(this.value);
      movie.bookmark = res.data.updateMovies[0].bookmark;
      this.$emit("input", movie);
    });
  }

  get labelNames() {
    return this.value.labels.map((l) => l.name).sort();
  }

  get actorLinks() {
    const names = this.value.actors.map(
      (a) =>
        `<a class="hover font-weight-bold" style="color: inherit; text-decoration: none" href="#/actor/${a._id}">${a.name}</a>`
    );
    names.sort();
    return names.join(", ");
  }

  get frontCover() {
    if (this.value.frontCover)
      return `${serverBase}/media/image/${
        this.value.frontCover._id
      }?password=${localStorage.getItem("password")}`;
    return `${serverBase}/broken`;
  }

  get backCover() {
    if (this.value.backCover)
      return `${serverBase}/media/image/${this.value.backCover._id}?password=${localStorage.getItem(
        "password"
      )}`;
    return this.frontCover;
  }
}
